import { render, staticRenderFns } from "./senderList.vue?vue&type=template&id=b9018b3e&"
import script from "./senderList.vue?vue&type=script&lang=js&"
export * from "./senderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports